import {Component} from '@angular/core';
import {Document} from '../documents/document-countries/document-countries.component';

@Component({
  selector: 'app-driving-rules',
  templateUrl: './driving-rules.component.html',
})
export class DrivingRulesComponent {

  countries: Array<Document> = [
    {
      countryName: 'Беларусь',
      img: 'by.svg',
      docHref: 'driving-rules-by.html'
    },
    {
      countryName: 'Россия',
      img: 'ru.svg',
      docHref: 'driving-rules-ru.html'
    },
  ];

  constructor() {
  }
}
